module.exports = __webpack_public_path__ + "static/media/Societe-Expertise-Immobiliere-Vaud.2fa7ab64.jpg";